import {Observable} from 'rxjs';
import {reset, startSubmit, stopSubmit} from 'redux-form';

import {combineEpics} from 'web-app/util/redux-observable';
import * as FileHelpers from 'web-app/react/components/file-upload/typed-helpers';
import * as FeedItemApi from 'web-app/react/entities/feed/items/api';

import * as Actions from './actions';
import * as Constants from './constants';

const comment = action$ =>
    action$.ofType(Actions.comment.type).mergeMap(({payload}) =>
        Observable.concat(
            Observable.of(startSubmit(Constants.COMMENT_FORM)),
            FeedItemApi.comment(payload.originatorId, payload.body)
                .mergeMap(() =>
                    Observable.concat(
                        Observable.of(Actions.commentSuccess.action(payload.originatorId)),
                        Observable.of(reset(Constants.COMMENT_FORM)),
                        Observable.of(stopSubmit(Constants.COMMENT_FORM)),
                    ),
                )
                .catch(() =>
                    Observable.concat(
                        Observable.of(Actions.commentFailed.action(payload.originatorId)),
                        Observable.of(stopSubmit(Constants.COMMENT_FORM)),
                    ),
                ),
        ),
    );

const likeComment = action$ =>
    action$.ofType(Actions.likeComment.type).mergeMap(({payload}) =>
        FeedItemApi.likeComment(payload.commentId, payload.liked)
            .map(() => Actions.likeCommentSuccess.action(payload.commentId))
            .catch(() => Observable.of(Actions.likeCommentFailed.action(payload.commentId))),
    );

const likeActivity = action$ =>
    action$.ofType(Actions.likeActivity.type).mergeMap(({payload}) =>
        (payload.liked ? FeedItemApi.unlike : FeedItemApi.like)(`Activity:${payload.activityId}`)
            .map(() => Actions.likeActivitySuccess.action(payload.activityId))
            .catch(() => Observable.of(Actions.likeActivityFailed.action(payload.activityId))),
    );

const deleteComment = action$ =>
    action$.ofType(Actions.deleteComment.type).mergeMap(({payload}) =>
        FeedItemApi.deleteComment(payload.commentId)
            .map(() => Actions.deleteCommentSuccess.action(payload.commentId))
            .catch(() => Observable.of(Actions.deleteCommentFailed.action(payload.commentId))),
    );

const uploadImageFromURL = action$ =>
    action$.ofType(Actions.uploadImageFromURL.type).mergeMap(({payload}) =>
        FileHelpers.genericUploadImageObservable({imageURL: payload.url, imageFor: 'Activities'})
            .map(({imageId}) => {
                payload.cb(imageId);
                return Actions.uploadImageFromURLSuccess.action(imageId);
            })
            .catch(e => [Actions.uploadImageFromURLFailed.action(e)])
            .do(({type}) => {
                if (type === Actions.uploadImageFromURLFailed.type) {
                    payload.cb();
                }
            }),
    );

export default combineEpics(comment, likeComment, likeActivity, deleteComment, uploadImageFromURL);
